import React, { Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Home from './components/landing/Home';
import Privacy from './components/landing/Privacy';
import Legal from './components/landing/Legal';
import FAQ from './components/landing/FAQ';
import Cafecin from './components/landing/Cafecin';
import Conocenos from './components/landing/Conocenos';
// import Metas from './components/landing/Metas';
// import Ahorro from './components/landing/Ahorro';
import Deuda from './components/landing/Deuda';
import Retiro from './components/landing/Retiro';
import Plan from './components/landing/Plan';
import ReferralLanding from './components/landing/ReferralLanding';
import RetirementContainer from './containers/RetirementContainer';
import GoalsContainer from './containers/GoalsContainer';
import DebtConsolidationContainer from './containers/DebtConsolidationContainer';
// import RegistrationContainer from './containers/RegistrationContainer';
// import SavingsContainer from './containers/SavingsContainer';
// import CurrencyContainer from './containers/CurrencyContainer';
// import BudgetContainer from './containers/BudgetContainer';

import ResultsGoals from './components/GoalsFlow/Results';
import ResultsRetirement from './components/RetirementFlow/Results';
import ResultsDebt from './components/DebtConsolidationFlow/Result';
import ResultsSavings from './components/SavingsFlow/Result';
import Loading from './components/ResultCreator/Loading';
import DiagnosticContainer from './containers/DiagnosticContainer';
// import TempResult from './components/DiagnosticFlow/TempResult';
// import ResultContainer from './containers/ResultContainer';
// import PlanResults from './components/ResultCreator/Results';
import CustomResult from './components/ResultCreator/CustomResult';
import GetInTouchContainer from './containers/GetInTouchContainer';
import Error from './components/shared/Error';
import ResultsPension from './components/RetirementFlow/ResultsPension';
import ExamplePlan from './components/RetirementFlow/ExamplePlan';
import TestContainer from './components/Test';
import HubspotForm from './components/HubspotForm';
import PlanGenerator from './components/RetirementPlanner/Form';
import Router from './components/Router/index';
import PensionPlanLanding from './components/PensionPlanLanding/index';
import PensionIMSS from './components/PilarPages/PensionIMSS';
import Congrats from './views/Congrats';
import ScheduleTimeRedirect from './components/ScheduleTimeRedirect';
import Failure from './components/Failure';
import RetirementConversionFormContainer from './containers/RetirementConversionFormContainer';

const AllRoutes = () => (
  <Switch>
    <Route path="/" component={Home} exact />
    <Route path="/pension-imss" component={PensionIMSS} exact />
    <Route path="/felicidades/:phone/:referralId?/:planLink?" component={Congrats} exact />
    <Route path="/error" component={Failure} exact />
    <Route path="/diagnostico" component={ScheduleTimeRedirect} exact />
    {/* <Route path="/aviso-de-privacidad" component={Privacy} /> */}
    {/* <Route path="/aviso-legal" component={Legal} /> */}
    <Route strict exact path="/retiro" component={Retiro} />
    <Route strict exact path="/plan" component={Plan} />
    <Route path="/retiro/empezar/:referralId?" component={RetirementContainer} />
    <Route path="/plan-generator" component={PlanGenerator} />
    {/* <Route path="/test" component={TestContainer} /> */}
    <Route path="/error/:number" component={Error} />
    {/* <Route strict exact path="/deuda" component={Deuda} /> */}
    {/* <Route path="/deuda/empezar" component={DebtConsolidationContainer} /> */}
    <Route exact path="/plan/res/:uuid/:mode?" component={CustomResult} />
    <Route exact path="/plan/empezar/:step?" component={DiagnosticContainer} />
    <Route exact path="/router" component={Router} />
    {/* <Route exact path="/plan-de-pension" component={PensionPlanLanding} /> */}
    <Route path="/contacto/:tool?/:source?/:planLink?" component={GetInTouchContainer} />
    <Route
      path="/retiro/contacto/:referralId?/:planLink?"
      component={RetirementConversionFormContainer}
    />

    <Route exact path="/retiro/res/:uuid" component={ResultsRetirement} />
    <Route exact path="/retiro/res/73/:uuid/:referralId?" component={ResultsPension} />
    {/* <Route exact path="/retiro/:referralId" component={ReferralLanding} /> */}
    {/* <Route exact path="/retiro/contacto/:referralId?/:planLink?" component={HubspotForm} /> */}
    <Route
      preserveScrollPosition={false}
      path="/retiro/73/PlanDeEjemplo/:uuid?/:referralId?"
      component={ExamplePlan}
    />
    <Route path="/conocenos" component={Conocenos} />
    {/* <Route path="/faq" component={FAQ} /> */}
    {/* <Route path="/cafecin" component={Cafecin} /> */}
    {process.env.REACT_APP_NODE_ENV === 'development' ? (
      <Fragment>
        <Route path="/metas/res" component={ResultsGoals} />
        <Route path="/ahorro/res" component={ResultsSavings} />
        <Route exact path="/retiro/res" component={ResultsPension} />
        <Route path="/deuda/res" component={ResultsDebt} />
        <Route path="/loading" component={Loading} />
        <Route exact path="/testdebt" component={DebtConsolidationContainer} />
        <Route exact path="/testgoals" component={GoalsContainer} />
      </Fragment>
    ) : (
      <Route render={() => <Redirect to="/" />} />
    )}
  </Switch>
);

export default AllRoutes;
